import { render, staticRenderFns } from "./AccountValidate.vue?vue&type=template&id=f12c51d4&"
import script from "./AccountValidate.vue?vue&type=script&lang=js&"
export * from "./AccountValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports